import axios from "axios";
import { useEffect, useState } from "react";
import { BASE_URL } from "../Components/Api/Api";
import * as React from "react";
import Cookies from "js-cookie";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import CustomModal from "../Components/CustomModal";
import { logoutStatic } from "../../StateManagement/authSlice";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTelegram, faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import { faSms, faVoicemail } from "@fortawesome/free-solid-svg-icons";
import Helmet from "../Components/Helment";

function Referral() {
  const dispatch = useDispatch();
  const authState = useSelector((state) => state.auth);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const [userId, setUserId] = useState(null);
  const fetchdata = async () => {
    const bodyFormData = new FormData();
    bodyFormData.append("guid", Cookies.get("guid"));
    try {
      const response = await axios.post(BASE_URL, bodyFormData, {
        headers: {
          "Content-type": "multipart/form-date",
          Accept: "application/json",
          cmd: "guid",
        },
      });
      if (response.status === 200) {
        const data = await response;
        setUserId(data?.data?.UserId);
      } else {
        console.error(`API request failed with status: ${response.status}`);
      }
    } catch (error) {
      console.error("Error while fetching menu data:", error);
    }
  };

  useEffect(() => {
    fetchdata();
  }, [isModalOpen]);

  useEffect(() => {
    if (userId === "0") {
      dispatch(logoutStatic());
    }
  }, [userId]);
  const handleCopyClick = (event) => {
    // Get the content of the clicked element
    const content = event.target.innerText;

    // Create a temporary textarea element to hold the text
    const textarea = document.createElement("textarea");
    textarea.value = content;

    // Set the textarea to be invisible
    textarea.style.position = "absolute";
    textarea.style.left = "-9999px";

    // Append the textarea to the document
    document.body.appendChild(textarea);

    // Select the text in the textarea
    textarea.select();

    // Execute the copy command
    document.execCommand("copy");

    // Remove the temporary textarea
    document.body.removeChild(textarea);

    alert("کد معرف کپی شد. ");
  };
  const closeModal = () => {
    setIsModalOpen(false);
  };
  return (
    <Helmet title="همکاری در فروش">
      <div className="mt-5 pt-5">
        {/* {isModalOpen && (
          )} */}
          <CustomModal isOpen={isModalOpen} closeModal={closeModal} />
        <div className="card wd-75 wm-100 m-auto">
          <div className="card-body px-4">
            <p className="fs-4 fw-bold text-center">
              همکاری در فروش - کسب درآمد
            </p>
            <hr />
            <p className="text-primary lh-5 px-3">
              لینک اختصاصی خود را با دوستانتان به اشتراک بگذارید سپس افرادی که
              با لینک زیر به سایت مراجعه کنند ، هر مبلغی را که به عنوان کسب
              درآمد یا کش بک ( پاداش خرید ) دریافت کنند ، شما نیز به میزان 14%
              از آن (زیر مجموعه مستقیم) پارسی دریافت می کنید و همچنین پارسی ، از
              پاداش های دعوت شدگان توسط زیر مجموعه تان به شما تعلق می گیرد
            </p>
            <hr />

            {authState?.isLoggedIn ? (
              <>
                {" "}
                <h6 className="text-center text-primary m-4">
                  جهت کپی کردن لینک معرفی کلیک کنید
                </h6>
                <div
                  className="d-flex justify-content-center align-items-center my-4"
                  onClick={handleCopyClick}
                >
                  <OverlayTrigger
                    placement="top"
                    overlay={
                      <Tooltip>{"جهت کپی کردن لینک معرف کلیک نمایید"}</Tooltip>
                    }
                  >
                    <span className="reagent-link">{`https://taab30.com/?rt=${userId}`}</span>
                  </OverlayTrigger>
                </div>
                <div className="d-flex flex-row justify-content-center flex-wrap align-items-center gap-1 m-2">
                  <Link
                    to={`https://telegram.me/share/url?url=http://taab30.parvandi.com/?rt=${userId}`}
                    className="social-link d-flex justify-content-between gap-1 align-items-center"
                  >
                    <FontAwesomeIcon
                      icon={faTelegram}
                      className="header-icon"
                    />
                    Telegram
                  </Link>
                  <Link
                    to={`whatsapp://send/?text=http://taab30.parvandi.com/?rt=${userId}`}
                    className="social-link d-flex justify-content-between gap-1 align-items-center"
                  >
                    <FontAwesomeIcon
                      icon={faWhatsapp}
                      className="header-icon"
                    />
                    <span>WhatsApp</span>
                  </Link>
                  <Link
                    to={`mailto:?subject= لینک عضویت تاب30&body=http://taab30.parvandi.com/?rt=${userId}`}
                    className="social-link d-flex justify-content-between gap-1 align-items-center"
                  >
                    <FontAwesomeIcon
                      icon={faVoicemail}
                      className="header-icon"
                    />
                    Email
                  </Link>
                  <Link
                    to={`http://taab30.parvandi.com/sms:?&body=%D9%84%D
                        B%8C%D9%86%DA%A9%20%D8%B9%D8%B6%D9%88%DB%8C%D8%AA%20%D8%AA%D8%A7%D8%A830%0D%0Ahttp://taab30.parvandi.com/?rt=${userId}`}
                    className="social-link sms  "
                  >
                    <FontAwesomeIcon icon={faSms} className="header-icon" />
                    SMS
                  </Link>
                </div>
              </>
            ) : (
              <div id="alerts">
                <div
                  dir="rtl"
                  className="alert mt-2 shadow alert-primary alert-dismissible fade show"
                  role="alert"
                >
                  شما کاربر مهمان می باشید{" "}
                  <b> با عضویت در تاب سی کد معرف خود را دریافت می کنید. </b>
                  <button
                    className="btn btn-primary btn-lg"
                    onClick={() => setIsModalOpen(true)}
                  >
                    ثبت نام در تاب 30
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </Helmet>
  );
}
export default Referral;
